"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconMoreOutline = _interopRequireDefault(require("./IconMoreOutline"));
var IconMoreVerticalOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconMoreOutline.default).withConfig({
  displayName: "IconMoreVerticalOutline",
  componentId: "c11n-8-107-0__sc-1msz84c-0"
})(["transform:rotate(90deg);"]);
var _default = IconMoreVerticalOutline;
exports.default = _default;